import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import { engineeringBomListColumns } from "@patronix/domain/list";
import { ebomListQuery } from "@/features/engineering/api";
import { EbomListPage } from "@/features/engineering/EbomListPage";
import { validateEbomSearch, type EbomSearch } from "@/features/engineering/search";
import { viewQuery } from "@/lib/listView";

export const Route = createFileRoute("/_app/engineering/engineering-boms")({
  validateSearch: validateEbomSearch,
  loaderDeps: ({ search }) => ({ status: search.status, q: search.q, f: search.f, s: search.s }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureInfiniteQueryData(ebomListQuery({ status: deps.status, q: deps.q, ...viewQuery(engineeringBomListColumns, deps) })),
  component: Page,
});

function Page() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const setSearch = useCallback(
    (patch: Partial<EbomSearch>) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true }),
    [navigate],
  );
  return <EbomListPage search={search} setSearch={setSearch} />;
}
